import React from "react";
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import { IconQuestionCircle } from "@amzn/stencil-react-components/icons";

export const IconWithTooltip = withTooltip<{color?: string}>()(IconQuestionCircle);
